import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AskADoctorOptionCardComponent } from '../ask-a-doctor-option-card/ask-a-doctor-option-card.component';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PostGetQuickCareVisitRequest } from '../../../../shared/model/getcarenow/PostGetQuickCareVisitRequest';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-ask-a-doctor-mobile',
  imports: [CommonModule, TranslateModule, MatProgressSpinnerModule, MatCardModule, MatButtonModule, AskADoctorOptionCardComponent],
  templateUrl: './ask-a-doctor.component.html',
  styleUrl: '../../../../../styles.css',
})
export class AskADoctorComponent {

  @Input() locale: string | null = null;
  @Input() isPlus: boolean | null = null;
  @Input() quickCareOptions: Array<any> = [];

  public title: string = 'TITLE';
  public description: string = 'DESCRIPTION';
  public showMoreText: string = 'SHOW_MORE';  
  

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(this.locale || 'en-US'); // Default to 'en-US' if no locale is provided
  }


  ngOnInit(): void {
   this.translate.get('QUICKCARE.TITLE').subscribe((translated: string) => {
      this.title = translated;
    });

    this.translate.get('QUICKCARE.DESCRIPTION').subscribe((translated: string) => {
      this.description = translated;
    });

    this.translate.get('SHOW_MORE').subscribe((translated: string) => {
      this.showMoreText = translated;
    });
  }

  showMeMore() {
    const eptID = sessionStorage.getItem("eptID");
    const isMobile = window.location.href.includes('mobile');

    if (eptID == null || eptID == undefined || eptID == "") {
      this.showMeMoreUnAuth(isMobile);
    }
    else {
      this.showMeMoreAuth();
    }
  }

  showMeMoreUnAuth(isMobile: boolean) {
    // Mobile deep link mymemorialcare://fdiredirect?webid=WP-24KmmNRwMLw-2B-2FmGPMLsDFPpw-3D-3D-24DKl7OCYL8WM9sv1J7ugKsJ0S5OyI4xkU9nob8mZSAA0-3D&iosid=WP-24KmmNRwMLw-2B-2FmGPMLsDFPpw-3D-3D-24DKl7OCYL8WM9sv1J7ugKsJ0S5OyI4xkU9nob8mZSAA0-3D&androidid=WP-24KmmNRwMLw-2B-2FmGPMLsDFPpw-3D-3D-24DKl7OCYL8WM9sv1J7ugKsJ0S5OyI4xkU9nob8mZSAA0-3D
    var deepLink = isMobile ? environment.mobile_quickcare_deep_link_base_url : environment.web_quickcare_unauth_deep_link_base_url; // For web users, use the web deep link
    
    if (isMobile == false) {
      deepLink += this.locale == 'es-US' ? '?l=es' : '?l=en'; // Append language parameter for web link
    }
    
    var platform = isMobile ? 'mobile-plus' : 'web';
    console.log("Show me more clicked");
    console.log(deepLink);

    this.monitoringService.logEvent('ShowMore/NoAuth', { feature: 'get-care-now', subfeature: 'QuickCare', platform: platform }); // log as web event
    window.location.href = deepLink;
  }

  showMeMoreAuth() {
    var deepLink: string = '';

    if (this.isPlus == null) {
      deepLink = environment.web_quickcare_deep_link_base_url; // Default to web deep link if isPlus is null
      this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'QuickCare', platform: 'web' });
    }
    else {
      deepLink = this.isPlus 
      ? environment.mobile_quickcare_deep_link_base_url // For Plus users, use the mobile deep link
      : environment.epic_quickcare_deep_link_base_url; //  For non-Plus users, use the epic deep link

      var mobilePlatform = this.isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'QuickCare', platform: mobilePlatform });
    }

    console.log("Show me more clicked");
    console.log(deepLink);

    window.location.href = deepLink;

  }

}
